import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import 'firebase/compat/analytics'
import 'firebase/compat/functions'
import 'element-ui/lib/theme-chalk/index.css'
import { Button, Checkbox, CheckboxButton, Switch, Select, Option, OptionGroup, Input, Loading, Form, FormItem, Row, Col } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'

firebase.initializeApp({
  apiKey: "AIzaSyCNxTsl0NhDRGN47QrV_cahNqpaW0FBmLk",
  authDomain: "tour-de-france-671b8.firebaseapp.com",
  databaseURL: "https://tour-de-france-671b8.firebaseio.com",
  projectId: "tour-de-france-671b8",
  storageBucket: "tour-de-france-671b8.appspot.com",
  messagingSenderId: "724378831827",
  appId: "1:724378831827:web:818bdec660e9bfd5b07d26",
  measurementId: "G-BQTE3C2P7K"
})
firebase.analytics()

Vue.config.productionTip = false

locale.use(lang)

Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Loading)

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCNxTsl0NhDRGN47QrV_cahNqpaW0FBmLk",
    libraries: "places"
  }
})

Vue.mixin({
  methods: {
    db: () => firebase.database(),
  },
})

new Vue({
  render: h => h(App),
}).$mount('#app')
